var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57294 2.0918L0.985021 9.75097C0.890428 9.91478 0.840378 10.1005 0.839848 10.2897C0.839318 10.4788 0.888328 10.6648 0.982002 10.8292C1.07568 10.9935 1.21075 11.1305 1.37378 11.2264C1.53681 11.3223 1.72212 11.3739 1.91127 11.376H11.0871C11.2763 11.3739 11.4616 11.3223 11.6246 11.2264C11.7876 11.1305 11.9227 10.9935 12.0164 10.8292C12.11 10.6648 12.1591 10.4788 12.1585 10.2897C12.158 10.1005 12.1079 9.91478 12.0134 9.75097L7.42544 2.0918C7.32887 1.93261 7.19291 1.80099 7.03067 1.70964C6.86843 1.6183 6.68538 1.57031 6.49919 1.57031C6.313 1.57031 6.12995 1.6183 5.96771 1.70964C5.80546 1.80099 5.6695 1.93261 5.57294 2.0918Z",
    stroke: "#E00000",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 4.875V7.04167",
    stroke: "#E00000",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9.21094H6.50542",
    stroke: "#E00000",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/IconWarning.75e1bbf1aebe6125b4e6f691745ae47a.svg";
export { ForwardRef as ReactComponent };